import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export const radioWrapper = css`
  display: flex;
`;

export const secondaryLabel = css`
  flex-grow: 1;
  align-self: center;
  text-align: right;
  ${responsiveText.BODY.SM};
  color: var(--neutral-black-40);
  font-weight: 400;
  margin-bottom: ${spacing.lg}px;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      margin-bottom: ${spacing.sm}px;
    `,
  )};
`;
